// extracted by mini-css-extract-plugin
module.exports = {"avatar":"PrincipalEditorControl_avatar__1sUXW","name":"PrincipalEditorControl_name__1iaFI"};